module.exports = __webpack_public_path__ + "img/78.a9540ad5.jpg";